class BSPopover extends HTMLElement {
  constructor() {
    super();
    this.options = {};

    if(this.dataset.bsTrigger != undefined)
      this.options.trigger = this.dataset.bsTrigger;
    
    new bootstrap.Popover(this, this.options);
  }
}
if (!window.customElements.get("bs-popover")) {
  window.customElements.define("bs-popover", BSPopover);
}

class ThemeTooltip {
  constructor(element) {
    this.options = {};
    new bootstrap.Tooltip(element, this.options);
  }
}

class BSTooltip extends HTMLElement {
  constructor() {
    super();
    new ThemeTooltip(this);
  }
}
if (!window.customElements.get("bs-tooltip")) {
  window.customElements.define("bs-tooltip", BSTooltip);
}

class BSModal extends HTMLElement {
  delay; modal; scroll; scrollHandler; cansShow; days; backdrop;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.backdrop = this.dataset.backdrop != "false";
    this.delay = isNaN(parseInt(this.dataset.delay)) ? 0 : parseInt(this.dataset.delay);
    this.scroll = isNaN(parseInt(this.dataset.scroll)) ? 0 : parseInt(this.dataset.scroll);
    this.days = isNaN(parseInt(this.dataset.remember)) ? 0 : parseInt(this.dataset.remember);
    this.modal = new bootstrap.Modal(this, {backdrop: this.backdrop});
    this.checkCanShow();

    if(this.cansShow){
      if(this.dataset.delay != undefined){
        this.handleDelay();
      }
  
      if(this.dataset.scroll != undefined){
        this.scrollHandler = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      if(this.dataset.remember != undefined && this.days > 0){
        this.addEventListener('hidden.bs.modal', () => this.remember());
      }
    }
  }

  remember = () => {
    localStorage.setItem(this.id, Date.now() + this.days * 24 * 60 * 60 * 1000);
  } 

  checkCanShow = () => {
    const stamp = parseInt(localStorage.getItem(this.id));
    this.cansShow = false;
    if(isNaN(stamp) || stamp < Date.now()){
      this.cansShow = true;
    }
  }

  handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrollPercentage = this.scroll / 100;
    if(scrollPosition / pageHeight > scrollPercentage){
      this.show();
      window.removeEventListener('scroll', this.scrollHandler, false);
    }
  }

  handleDelay = () => {
    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show = () => {
    this.modal.show();
  }

  hide = () => {
    this.modal.hide();
  }
}
if (!window.customElements.get("bs-modal")) {
  window.customElements.define("bs-modal", BSModal);
}

class BSTab extends HTMLElement {
  constructor() {
    super();
    this.tab = new bootstrap.Tab(this);
    this.init();
  }

  activate = () => {
    const nav = this.closest('.nav');
    if(nav){
      nav.classList.add('active');
    }
  }

  deactivate = () => {
    const nav = this.closest('.nav');
    if(nav){
      nav.classList.remove('active');
    }
  }

  init = () => {
    this.addEventListener('mouseover', (e) => {
      e.preventDefault();
      this.tab.show();
    });

    this.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.href != undefined)
        location.href = this.href;
    });
    this.addEventListener('shown.bs.tab', () => {
      this.activate();
    });
    this.addEventListener('hidden.bs.tab', () => {
      this.deactivate();
    });
  }
}
if (!window.customElements.get("bs-tab")) {
  window.customElements.define("bs-tab", BSTab);
}

class BSToast extends HTMLElement {
  toast;
  constructor() {
    super();
    this.toast = new bootstrap.Toast(this);
  }

  show = () => {
    this.toast.show();
  }

  hide = () => {
    this.toast.hide();
  }
}
if (!window.customElements.get("bs-toast")) {
  window.customElements.define("bs-toast", BSToast);
}